import { Rectangle, Sprite, Texture } from 'pixi.js';
import { TweenMax, Power1 } from 'gsap';
import { playWindowCharSfx } from '../../../../helpers/SoundManager';
import Scene3 from './Scene3';

export default class WindowCharacter extends Sprite {
  parentScene: Scene3;
  isVisible = false;

  soundDelay: any = null;

  constructor(parentScene: Scene3, textureName: string, hitX: number, hitY: number, hitW: number, hitH: number) {
    super(Texture.from(textureName));

    // vars
    this.parentScene = parentScene;

    // props
    this.alpha = 0;
    this.anchor.set(0.5);

    // interaction
    this.hitArea = new Rectangle(hitX, hitY, hitW, hitH);
    this.interactive = true;
    this.on('pointerover', this.playAnimation.bind(this));
    this.on('pointerdown', this.playAnimation.bind(this));

    // for hit area debug
    // setTimeout(() => {
    //   this.buttonMode = true;
    //   const hit = new Graphics();
    //   hit.beginFill(0xff0000, 0.5);
    //   hit.drawRect(hitX, hitY, hitW, hitH);
    //   hit.endFill();
    //   this.parent.addChild(hit);
    // }, 100);
  }

  playAnimation(): void {
    if (this.parentScene.isActive && !this.isVisible) {
      this.show(true);

      setTimeout(() => {
        this.show(false);
      }, 2000);
    }
  }

  // --------------------------------------------------------------
  // Show
  // --------------------------------------------------------------

  show(value: boolean): void {
    if (this.isVisible !== value) {
      this.isVisible = value;

      TweenMax.killTweensOf(this);
      if (this.isVisible) {
        TweenMax.to(this, 0.8, { alpha: 1, ease: Power1.easeInOut });
        this.soundDelay = setTimeout(() => {
          playWindowCharSfx();
        }, 100);
      } else {
        TweenMax.to(this, 1.2, { alpha: 0, ease: Power1.easeInOut });
        clearTimeout(this.soundDelay);
      }
    }
  }
}
